
export const common = {
  'call.us': 'お電話ください',
  'privacy.policy': 'プライバシーポリシー',
  'select.location': '場所を選択',
  'location.description': '適切な番号に電話するために場所を選択してください',
  'usa': '米国',
  'non.usa': '米国以外の通話またはWhatsApp',
  'documents.downloads': '書類とダウンロード',
  'item': '項目',
  'value': '値',
  'price': '価格',
  'product': '製品',
  'msrp': '希望小売価格',
};
